namespace $.$$ {
	$mol_style_define( $shm_hitalama_guide_page, {
		Title: { flex: { grow: 0 } },
		Tools: { flex: { grow: 1 } },
	})
}
